export default __webpack_public_path__ + "static/media/menu-02-campaign-w.15ac62ed.svg";